module.exports = __webpack_public_path__ + "static/media/searched_vendors.f0c8cc73.svg";